

import {
  defineComponent, useContext, useFetch
} from '@nuxtjs/composition-api';
import {usePageBuilder} from "../../../composables/Palmers";

export default defineComponent({
  name: 'PageBuilderStyles',
  props: {
    pageBuilder: {
      type: Object
    },
    id: {
      type: [String, Number]
    },
    updated: {
      type: [String, Number]
    }
  },
  setup(props) {
    const {config} = usePageBuilder();

    const {$vsf, route} = useContext();

    const urlToId = () => {
      let url = route.value.fullPath;

      if (url[0] === '/') {
        url = url.substring(1);
      }

      if (url[url.length - 1] === '/') {
        url = url.slice(0, -1);
      }

      //@ts-ignore
      url = url.replaceAll('/', '-');

      url = url.replace(/\?.*/, '');

      return url.toLowerCase();
    }


    useFetch(async () => {
      //@ts-ignore
      await $vsf.$magento.api.pageBuilder({
        content: props.pageBuilder,
        id: props.id ? props.id : urlToId(),
        config: config,
        updated: props.updated
      });
    })
  }
});
